import TagManager from 'react-gtm-module';

import { GTMEventCategory } from '@digital-dealer/enums';
import { BUSINESS_TYPE, GTM_ID } from '@digital-dealer/environments';

import IGTMEvent from './types/IGTMEvent';
import IGTMDimension from './types/IGTMDimension';
import TGTMDataLayer from './types/TGTMDataLayer';

enum Event {
  Default = 'GAEvent',
  CustomDimensionsUpdate = 'CustomDimensionsUpdate',
  Pageview = 'pageview',
}

const MULTIPLE_BRANDS_DIMENSION = 'Multi';
const APPLICATION_NAME = 'DigitalDealer';
const defaultDimension: IGTMDimension = {
  brand: window.xprops.brands.length === 1 ? window.xprops.brands[0] : MULTIPLE_BRANDS_DIMENSION,
  originalLocation: window.location.href,
  businessType: BUSINESS_TYPE,
  storeCodes: window.xprops.storeCodes,
  applicationName: APPLICATION_NAME,
};

class GTMHelper {
  private currentDimension: Partial<IGTMDimension> = defaultDimension;
  private getBrandName = (): string => window.xprops.brands.length === 1 ? window.xprops.brands[0] : MULTIPLE_BRANDS_DIMENSION;

  public init = (): void => {
    if (!GTM_ID) {
      return;
    }

    TagManager.initialize({
      gtmId: GTM_ID,
    });

    this.updateDimension(defaultDimension);
  };

  private emitGTMEvent = (dataLayer: TGTMDataLayer): void => {
    TagManager.dataLayer({
      dataLayer,
    });
  };

  public updateDimension = (dimension: Partial<IGTMDimension>): void => {
    this.currentDimension = {
      ...this.currentDimension,
      ...dimension,
    };

    if (typeof this.currentDimension.brand === 'string' && this.currentDimension.brand.length === 0) {
      this.currentDimension.brand = this.getBrandName();
    }

    this.emitGTMEvent({
      event: Event.CustomDimensionsUpdate,
      ...this.currentDimension,
    } as IGTMDimension);
  };

  public emitEvent = (category: GTMEventCategory, action: string, label: string = ''): void => {
    const dataLayer: IGTMEvent = {
      event: Event.Default,
      eventLabel: label,
      eventCategory: category,
      eventAction: action,
      ...this.currentDimension,
    };

    this.emitGTMEvent(dataLayer);
  };

  public emitPageView = (path: string): void => {
    this.emitGTMEvent({
      event: Event.Pageview,
      VirtualPageviewPath: path,
      ...this.currentDimension,
    } as TGTMDataLayer);
  };
}

export default new GTMHelper();
